import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  MessageCircle,
} from "lucide-react";
import api from "./axiosConfig";

export default function AideFaq() {
  const navigate = useNavigate();
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    api
      .get("/help/faq")
      .then((res) => setFaq(res.data.faq || []))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen px-4 pt-6 pb-20 font-sans bg-gray-50">
      {/* HEADER */}
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="p-2 transition bg-white rounded-full shadow-sm hover:bg-gray-100"
        >
          <ChevronLeft className="w-6 h-6 text-gray-700" />
        </button>
        <h1 className="text-xl font-bold text-gray-800">Aide & FAQ</h1>
      </div>

      {/* BLOC INTRO */}
      <div className="bg-[#f34141] p-6 rounded-3xl text-white mb-6 shadow-lg shadow-red-200">
        <h2 className="mb-2 text-2xl font-bold">Besoin d'aide ?</h2>
        <p className="text-sm text-red-100">
          Trouvez les réponses aux questions les plus fréquentes ci-dessous.
        </p>
      </div>

      {/* CONTENU FAQ */}
      {loading ? (
        <div className="mt-10 text-center text-gray-400">Chargement...</div>
      ) : (
        <div className="space-y-3">
          {faq.map((item, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 shadow-sm border border-transparent ${
                openIndex === index ? "ring-2 ring-red-100" : ""
              }`}
            >
              <button
                onClick={() => toggleItem(index)}
                className="flex items-center justify-between w-full p-5 text-left"
              >
                <div className="flex items-center gap-3">
                  <MessageCircle
                    size={20}
                    className={`${
                      openIndex === index
                        ? "text-[#f34141]"
                        : "text-gray-400"
                    }`}
                  />
                  <span className="text-sm font-bold text-gray-800">
                    {item.question}
                  </span>
                </div>

                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-[#f34141]" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-400" />
                )}
              </button>

              {openIndex === index && (
                <div className="px-5 pt-0 pb-5">
                  <p className="pl-8 text-sm leading-relaxed text-gray-600 border-l-2 border-gray-100">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ✅ FOOTER SUPPRIMÉ COMPLÈTEMENT */}
    </div>
  );
}


